export const getInitials = (firstName, lastName) => {
    if (!firstName && !lastName) return "";
    return (firstName == null || firstName == "" ? "AA" : firstName[0]) + (lastName == null || lastName == "" ? "" : lastName[0]);
}